import { render, staticRenderFns } from "./ReceiptsTable.vue?vue&type=template&id=4585fa21&scoped=true&"
import script from "./ReceiptsTable.vue?vue&type=script&lang=js&"
export * from "./ReceiptsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsTable.vue?vue&type=style&index=0&id=4585fa21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585fa21",
  null
  
)

export default component.exports